import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
  @media ${({ theme }) => theme.device.tablet} {
  }
`;

export const TextBox = styled.div`
  grid-area: text-area;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 5px;
  padding-left: 10px;
  gap: 7px;
`;

export const DataSet = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 10px;
  }
`;

export const TicketListWrapper = styled.div`
  width: 90%;
  height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  margin-bottom: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  gap: 10px;
  -webkit-appearance: none;
  @media ${({ theme }) => theme.device.tablet} {
  }
`;

export const Ticket = styled.div`
  width: 330px;
  height: 100px;
  border-radius: 5px;

  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 150px;
  }
`;

export const TicketImg = styled.img`
  float: left;
  width: 100px;
  height: 100px;
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 140px;
    height: 140px;
  }
`;

export const TicketTextWrapper = styled.div`
  height: 100px;
  padding-left: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    height: 140px;
    gap: 10px;
  }
`;

export const BankBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 130px;
  margin-top: 10px;
  @media ${({ theme }) => theme.device.tablet} {
    /* gap: 40px; */
  }
`;

export const BankWrapper = styled.div`
  width: 300px;
  height: 42px;
  border-radius: 5px 5px 0 0;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 -6px 5px -5px #808080; */
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 100px;
  }
`;

export const AccountHolderWrapper = styled.div`
  width: 300px;
  height: 40px;
  border-radius: 0 0 5px 5px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  /* box-shadow: 0 6px 5px -5px #808080; */
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-top: none;
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 100px;
  }
`;

export const BankSelect = styled.select`
  writing-mode: horizontal-tb;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  float: left;
  width: 100px;
  height: 38px;
  border: none;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  outline: none;
  text-align: center;
  font-size: 14px;
  font-family: "Bold";
  @media ${({ theme }) => theme.device.tablet} {
    width: 150px;
    height: 95px;
    font-size: 20px;
  }
`;

export const BankOption = styled.option`
  font-size: 14px;
  text-align: right;
  font-family: "Bold";
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 17px;
  }
`;

export const AccountInput = styled.input`
  width: 190px;
  height: 40px;
  text-align: center;
  border: none;
  float: left;
  font-size: 14px;
  font-family: "Bold";
  outline: none;
  @media ${({ theme }) => theme.device.tablet} {
    width: 480px;
    height: 95px;
    font-size: 20px;
  }
`;

export const AccountHolder = styled.div`
  border-radius: 5px;
  width: 200px;
  height: 48px;
  text-align: center;
  border: none;
  font-size: 14px;
  font-family: "Bold";
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${({ theme }) => theme.device.tablet} {
    width: 450px;
    height: 98px;
    font-size: 20px;
  }
`;

export const BankText = styled.span`
  font-size: 16px;
  text-align: left;
  font-family: "Bold";
  margin-bottom: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 25px;
  }
`;

export const RefundText = styled.span`
  font-size: 16px;
  text-align: left;
  font-family: "Bold";
  margin-bottom: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 25px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 10%;
  @media ${({ theme }) => theme.device.tablet} {
  }
`;

export const Button = styled.div`
  width: 300px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isChecked }) => (isChecked ? "#f44b59" : "#eaeaea")};
  border-radius: 5px;
  &:active {
    background-color: #e84661;
  }
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 100px;
    border-radius: 10px;
  }
`;

//version 1
export const RefundWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  height: 50px;
  gap: 20px;
`;

export const RefundSlideBtn = styled.button`
  width: auto;
  height: auto;
  background-color: white;
  border: 1.5px solid #f44b59;
  border-radius: 5%;
`;

//version2
export const RefundInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 90%;
  height: 30%;

  margin-bottom: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 80%;
    height: 30%;
    margin-top: 150px;
  }
`;
